// Polyfills for Node.js globals in browser environment

// Polyfill for process.env
if (typeof window !== 'undefined' && !window.process) {
  window.process = { env: {} };
}

// Copy Vite environment variables to process.env for compatibility
if (typeof window !== 'undefined' && window.process && import.meta.env) {
  Object.keys(import.meta.env).forEach(key => {
    if (key.startsWith('VITE_')) {
      const processKey = key.replace('VITE_', 'REACT_APP_');
      window.process.env[processKey] = import.meta.env[key];
    }
  });
}

// Polyfill for global
if (typeof window !== 'undefined') {
  window.global = window;
}

export {};